import { Modal } from "antd";
import PropTypes from "prop-types";

function ConfirmMultiDoc({
  isModalVisible,
  handleModalConfirm,
  handleModalCancel,
}) {
  return (
    <Modal
      title="File Upload Warning"
      open={isModalVisible}
      onOk={handleModalConfirm}
      onCancel={handleModalCancel}
      okText="Confirm"
      cancelText="Cancel"
      centered
    >
      <p>Your document will be converted to PDF.</p>
    </Modal>
  );
}

ConfirmMultiDoc.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  handleModalConfirm: PropTypes.func.isRequired,
  handleModalCancel: PropTypes.func.isRequired,
};

export { ConfirmMultiDoc };
